<template>
    <div class="bg-holder">
    <div class="film-bg-bottom"></div>
    </div>

</template>

<script>
import { inject } from "vue";

export default {
  name: "Background",
  components: {

  },
  setup() {
    const store = inject("store");
    return {
      state: store.state,
    };
  },
};
</script>

<style lang="scss">

.bg-holder{
  height:0px;
}

.film-bg-bottom {
  background: url("../assets/imgs/film-bg.png") top right repeat-x;
 height:11em;
  width: 100%;
  min-width: 1200px;
  position: relative;
  background-size: auto;
  transform: scaleY(-1);
  // bottom:20%;
  z-index:1;
   @media (max-width: 1200px)  {
        height:9em;
       background-size: cover;
  }
  @media (max-width: 600px) {
        height:7em;
       background-size: cover;
  }
}

</style>
